// js file - NO AUTO-SNAP VERSION
(function () {
  const SECTION_SELECTOR = '.customers-also-bought';

  function formatMoney(cents) {
    const value = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const format =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '{{amount_no_decimals}}';
        let formatted = window.Shopify.formatMoney(value, format);
        // Replace "Rs." or "Rs " with "₹"
        formatted = formatted.replace(/Rs\.?\s*/gi, '₹');
        return formatted;
      } catch (e) {
        // fall through
      }
    }

    // simple fallback: no decimals, INR-style prefix
    return '₹' + Math.round(value / 100);
  }

  /**
   * Amount discount calculation — mirrors bau-cart-saving-apply-discount-script.js.
   * Combo products: 25% off.
   * Non-combo products: 20% off if selected total ≥ ₹999, else 15%.
   * Returns total in paise.
   */
  function calcTotalForAmount(selected) {
    if (!selected.length) return 0;

    let hasCombo = false, hasNonCombo = false;
    let comboTotalPaise = 0, nonComboTotalPaise = 0;

    selected.forEach((item) => {
      const type = (item.dataset.productType || '').trim().toLowerCase();
      const price = Number(item.dataset.price || 0);
      if (type === 'combo') {
        hasCombo = true;
        comboTotalPaise += price;
      } else {
        hasNonCombo = true;
        nonComboTotalPaise += price;
      }
    });

    const totalRupees = (comboTotalPaise + nonComboTotalPaise) / 100;
    let comboDiscount = 0, nonComboDiscount = 0;

    if (hasCombo && hasNonCombo) {
      comboDiscount = 25;
      nonComboDiscount = totalRupees >= 999 ? 20 : 15;
    } else if (hasCombo) {
      comboDiscount = 25;
    } else if (hasNonCombo) {
      nonComboDiscount = totalRupees >= 999 ? 20 : 15;
    }

    // Match bau script: compute discount in rupees with Math.floor, then convert to paise
    const comboRupees = comboTotalPaise / 100;
    const nonComboRupees = nonComboTotalPaise / 100;
    const comboFinal = comboDiscount
      ? Math.floor(comboRupees * (1 - comboDiscount / 100))
      : comboRupees;
    const nonComboFinal = nonComboDiscount
      ? Math.floor(nonComboRupees * (1 - nonComboDiscount / 100))
      : nonComboRupees;

    return Math.round((comboFinal + nonComboFinal) * 100);
  }

  /**
   * BOGO discount calculation — mirrors bogo-script.js logic, pure (no DOM side-effects).
   * Normal products: cheapest 50% become ₹1, up to 4 free.
   * Combo products: at most 1 free.
   * Returns total in paise.
   */
  function calcTotalForBogo(selected) {
    if (!selected.length) return 0;

    const flat = [];
    selected.forEach((item) => {
      const price = Number(item.dataset.price || 0) / 100; // paise → rupees
      const type = (item.dataset.productType || '').trim().toLowerCase();
      flat.push({ price, isCombo: type.indexOf('combo') !== -1 });
    });

    const normal = flat.filter((i) => !i.isCombo);
    const combo = flat.filter((i) => i.isCombo);

    function applyBogo(items, maxFree) {
      const sorted = items.slice().sort((a, b) => a.price - b.price);
      const freeCount = Math.min(maxFree, Math.floor(sorted.length / 2));
      // Free items cost ₹1, matching bogo-script.js behaviour
      return sorted.reduce((sum, item, idx) => sum + (idx < freeCount ? 1 : item.price), 0);
    }

    const totalRupees = applyBogo(normal, 4) + applyBogo(combo, 1);
    return Math.round(totalRupees * 100); // rupees → paise
  }

  /**
   * Safely parse a Shopify variant ID from either a plain integer string
   * or a GID string (gid://shopify/ProductVariant/12345).
   */
  function parseVariantId(raw) {
    if (!raw) return 0;
    const str = String(raw).trim();
    if (str.includes('/')) {
      return Number(str.split('/').pop());
    }
    return Number(str);
  }

  function initCustomersAlsoBought(root = document) {
    const sections = root.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;

    const COUNT_WORDS = [
      'zero',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
    ];

    sections.forEach((section) => {
      if (section.dataset.customersAlsoBoughtInitialized === 'true') return;
      section.dataset.customersAlsoBoughtInitialized = 'true';

      const list = section.querySelector('[data-customers-also-bought-list]');
      const summary = section.querySelector('[data-customers-also-bought-summary]');
      const button = section.querySelector('[data-customers-also-bought-atc]');
      const items = list ? Array.from(list.querySelectorAll('[data-customers-also-bought-item]')) : [];

      if (!list || !summary || !button || !items.length) return;

      const rewardType = section.dataset.rewardType || '';
      const addAllOne = section.dataset.addAllOne || 'Add all one';
      const addAllTwo = section.dataset.addAllTwo || 'Add all two';
      const addAllThree = section.dataset.addAllThree || 'Add all three';
      const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';

      function getSelectedItems() {
        return items.filter((item) => item.classList.contains('is-active'));
      }

      function updateFormInputs() {
        const form = summary.querySelector('form');
        if (!form) return;

        const inputsContainer = form.querySelector('[data-bundle-inputs]');
        if (!inputsContainer) return;

        const selected = getSelectedItems();
        inputsContainer.innerHTML = '';

        selected.forEach((item, index) => {
          const variantId = parseVariantId(item.dataset.variantId);
          if (!variantId) return;

          inputsContainer.insertAdjacentHTML(
            'beforeend',
            `<input type="hidden" name="items[${index}][id]" value="${variantId}">` +  // numeric ID
              `<input type="hidden" name="items[${index}][quantity]" value="1">`
          );
        });
      }

      /** Build cart-like items for ip_sale_script applyTieredPricing(). */
      function selectedToCartItems(selected) {
        return selected.map((item) => {
          const variantId = parseVariantId(item.dataset.variantId);
          const price = Number(item.dataset.price || 0);
          return {
            key: 'cab-' + variantId,
            variant_id: variantId,
            product_id: Number(item.dataset.productId || 0),
            product_type: (item.dataset.productType || '').trim(),
            quantity: 1,
            original_line_price: price,
          };
        });
      }

      /**
       * Total price in paise, using the correct calculation for the active
       * reward type so the section preview matches the cart-drawer total.
       *
       * - 'amount' : mirrors bau-cart-saving-apply-discount-script.js
       * - 'Bogo'   : mirrors bogo-script.js (pure, no DOM side-effects)
       * - 'product': uses DotKeyIpSale.applyTieredPricing() (unchanged)
       * - default  : sum of base data-price values
       */
      async function getTotalPricePaise(selected) {
        if (!selected.length) return 0;

        if (rewardType === 'amount') {
          return calcTotalForAmount(selected);
        }

        if (rewardType === 'Bogo') {
          return calcTotalForBogo(selected);
        }

        // 'product' type or unrecognised: use DotKeyIpSale tiered pricing
        const IpSale = window.DotKeyIpSale;
        if (!IpSale || typeof IpSale.applyTieredPricing !== 'function') {
          return selected.reduce(
            (sum, item) => sum + Number(item.dataset.price || 0),
            0
          );
        }

        const cartItems = selectedToCartItems(selected);
        await Promise.all(
          cartItems.map((i) => IpSale.getComparePriceByVariantId(i.variant_id))
        );

        const data = IpSale.applyTieredPricing(cartItems);

        // If no IP-sale discount applies, show normal prices (not compare-at)
        if (!data || !Array.isArray(data.discountedItems) || !data.discountedItems.length) {
          return selected.reduce(
            (sum, item) => sum + Number(item.dataset.price || 0),
            0
          );
        }

        return IpSale.getTotalFromPricingResult(data);
      }

      async function recalcTotals() {
        const totalPriceEl = summary.querySelector('[data-total-price]');
        const totalCompareEl = summary.querySelector('[data-total-compare-at]');
        const totalDiscountPercentEl = summary.querySelector('[data-total-discount-percent]');

        const selected = getSelectedItems();
        let totalCompare = 0;

        if (rewardType === 'amount' || rewardType === 'Bogo') {
          // For script-based discounts the additional discount is applied *on top of*
          // the Shopify price, so data-price is the pre-discount reference (compare-at).
          totalCompare = selected.reduce(
            (sum, item) => sum + Number(item.dataset.price || 0), 0
          );
        } else {
          // For 'product' type / default: use Shopify's own compare-at price (MRP).
          selected.forEach((item) => {
            const price = Number(item.dataset.price || 0);
            const compareAt = Number(item.dataset.compareAtPrice || 0);
            if (compareAt > price) {
              totalCompare += compareAt;
            }
          });
        }

        const totalPrice = await getTotalPricePaise(selected);

        if (totalPriceEl) {
          totalPriceEl.textContent = formatMoney(totalPrice);
        }

        const discount = totalCompare > 0 ? totalCompare - totalPrice : 0;
        const hasDiscount = discount > 0 && totalCompare > 0 && totalPrice > 0;

        if (totalCompareEl) {
          if (hasDiscount) {
            totalCompareEl.textContent = formatMoney(totalCompare);
            totalCompareEl.hidden = false;
          } else {
            totalCompareEl.hidden = true;
          }
        }

        if (totalDiscountPercentEl) {
          if (hasDiscount) {
            const discountPercent = Math.round((discount / totalCompare) * 100);
            totalDiscountPercentEl.textContent = discountPercent + '%off';
            totalDiscountPercentEl.hidden = false;
          } else {
            totalDiscountPercentEl.hidden = true;
          }
        }

        if (!selected.length) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }

        const count = selected.length;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (isMobile) {
          const safeCount = Math.max(1, Math.min(count, 15));
          const countWord = COUNT_WORDS[safeCount];
          const priceStr = formatMoney(totalPrice);
          const discountPercent = hasDiscount ? Math.round((discount / totalCompare) * 100) : 0;
          button.innerHTML =
            '<span class="customers-also-bought__btn-label">Add all ' + countWord + '</span> ' +
            (hasDiscount ? '<span class="customers-also-bought__btn-compare">' + formatMoney(totalCompare) + '</span> ' : '') +
            '<span class="customers-also-bought__btn-price">' + priceStr + '</span>' +
            (hasDiscount ? ' <span class="customers-also-bought__btn-discount">' + discountPercent + '%off</span>' : '');
        } else {
          let label;
          if (!count) {
            label = addAllOne;
          } else {
            const safeCount = Math.max(1, Math.min(count, 15));
            const countWord = COUNT_WORDS[safeCount];
            label = 'Add all ' + countWord;
          }
          button.textContent = label;
        }

        updateFormInputs();
      }

      function toggleCard(card) {
        const pressedBtn = card.querySelector('.customers-also-bought__checkbox-button');
        const isActive = card.classList.toggle('is-active');
        if (pressedBtn) {
          pressedBtn.setAttribute('aria-pressed', String(isActive));
        }
        recalcTotals();
      }

      // Replace "Rs." with "₹" in Liquid-rendered prices
      function replaceRsInPrices() {
        const priceElements = section.querySelectorAll(
          '[data-item-price], [data-item-compare-at-price]'
        );
        priceElements.forEach((el) => {
          if (el.textContent) {
            el.textContent = el.textContent.replace(/Rs\.?\s*/gi, '₹');
          }
        });
      }

      // Initial total calc
      recalcTotals().then(() => {
        if (!window.DotKeyIpSale) {
          const retry = () => {
            if (window.DotKeyIpSale) recalcTotals();
          };
          setTimeout(retry, 400);
          document.addEventListener('DOMContentLoaded', retry, { once: true });
        }
      });

      // Replace Rs. in Liquid-rendered prices
      replaceRsInPrices();

      let lastMobile = window.matchMedia('(max-width: 749px)').matches;
      window.addEventListener('resize', () => {
        const nowMobile = window.matchMedia('(max-width: 749px)').matches;
        if (nowMobile !== lastMobile) {
          lastMobile = nowMobile;
          recalcTotals();
        }
      });

      // Checkbox + card click handlers
      items.forEach((item) => {
        const checkboxBtn = item.querySelector('.customers-also-bought__checkbox-button');
        if (!checkboxBtn) return;

        checkboxBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          toggleCard(item);
        });

        item.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          if (event.target.closest('.customers-also-bought__checkbox-button')) return;
          if (event.target.closest('[data-cab-variant-selector]')) return;
          if (list.dataset.justDragged === 'true') return;
          toggleCard(item);
        });
      });

      list.addEventListener('click', (event) => {
        const varBtn = event.target.closest('[data-cab-variant-btn]');
        if (!varBtn) return;
        event.stopPropagation();

        const card = varBtn.closest('[data-customers-also-bought-item]');
        if (!card) return;

        // Deactivate all sibling variant buttons
        card.querySelectorAll('[data-cab-variant-btn]').forEach((btn) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        });
        varBtn.classList.add('is-selected');
        varBtn.setAttribute('aria-pressed', 'true');

        //color shad name
      // ✅ Update color name text
        const colorText = card.querySelector('.selected-color-name');

        if (colorText && varBtn.classList.contains('color_buttons')) {
          const newColor = varBtn.getAttribute('aria-label') || '';
          colorText.textContent = newColor;
        }
        // end code here

        // Update card data attributes (used by recalcTotals + addSelectedToCart)
        card.dataset.variantId = varBtn.dataset.variantId;
        card.dataset.price = varBtn.dataset.price;
        card.dataset.compareAtPrice = varBtn.dataset.compareAtPrice || '0';

        // Update card image
        const imgEl = card.querySelector('.customers-also-bought__image');
        if (imgEl && varBtn.dataset.image) {
          imgEl.removeAttribute('srcset');
          imgEl.src = varBtn.dataset.image;
        }

        // Update variant title span
        const titleSpan = card.querySelector('[data-variant-title]');
        if (titleSpan) titleSpan.textContent = varBtn.dataset.title || '';

        // Update displayed price
        const priceEl = card.querySelector('[data-item-price]');
        const compareEl = card.querySelector('[data-item-compare-at-price]');
        const price = Number(varBtn.dataset.price || 0);
        const compareAt = Number(varBtn.dataset.compareAtPrice || 0);
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (compareEl) {
          if (compareAt > price && compareAt > 0) {
            compareEl.textContent = formatMoney(compareAt);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        // Recalc totals if card is active
        if (card.classList.contains('is-active')) recalcTotals();
      });

      async function addSelectedToCart() {
        const selected = getSelectedItems();
        if (!selected.length) return;

        const itemsPayload = selected
          .map((item) => ({
            id: parseVariantId(item.dataset.variantId),
            quantity: 1,
          }))
          .filter((item) => item.id > 0);

        button.disabled = true;
        button.classList.add('loading');

        try {
          // Step 1: Add items to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: itemsPayload }),
          });

          if (!response.ok) {
            throw new Error('Cart add failed');
          }

          await response.json();

          // Step 2: Fetch fresh cart sections and open the drawer.
          // Mirrors the openCustom() pattern in product-form.js which is the
          // established working approach for this theme.
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
            if (sectionsRes.ok) {
              const sectionsData = await sectionsRes.json();
              if (typeof cartDrawer.renderContentsCustom === 'function') {
                cartDrawer.renderContentsCustom(sectionsData, true);
              } else if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents({ sections: sectionsData });
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              } else if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }
            }
          }
        } catch (e) {
          console.error('customers-also-bought: error adding items to cart', e);
        } finally {
          button.disabled = false;
          button.classList.remove('loading');
        }
      }

      const form = summary.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          addSelectedToCart();
        });
      }

      // Update the current-product card when PDP variant changes
      const currentProductCard = list.querySelector('[data-is-current-product]');
      if (currentProductCard) {
        function updateCurrentProductCard({ variantId, price, compareAtPrice, imageSrc }) {
          currentProductCard.dataset.variantId = variantId;
          currentProductCard.dataset.price = price;
          currentProductCard.dataset.compareAtPrice = compareAtPrice;

          const priceEl = currentProductCard.querySelector('[data-item-price]');
          const compareEl = currentProductCard.querySelector('[data-item-compare-at-price]');

          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compareAtPrice > price && compareAtPrice > 0) {
              compareEl.textContent = formatMoney(compareAtPrice);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          if (imageSrc) {
            const img = currentProductCard.querySelector('.customers-also-bought__image');
            if (img) {
              img.removeAttribute('srcset');
              img.src = imageSrc;
            }
          }

          if (currentProductCard.classList.contains('is-active')) {
            recalcTotals();
          }
        }

        // Custom event from npdp-details.js handleOptionClick
        document.addEventListener('dnk:pdp:variant-change', (event) => {
          updateCurrentProductCard(event.detail);
        });

        // Pub/sub fallback for standard Shopify option selectors
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data && event.data.variant;
            if (!variant) return;
            updateCurrentProductCard({
              variantId: variant.id,
              price: variant.price,
              compareAtPrice: variant.compare_at_price || 0,
              imageSrc: variant.featured_image ? variant.featured_image.src : null,
            });
          });
        }
      }

      // Mouse drag to swipe carousel (desktop)
      let isDragging = false;
      let dragStartX = 0;
      let dragScrollLeft = 0;
      let hasDragged = false;

      function onListMouseDown(e) {
        if (e.target.closest('a') || e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        dragStartX = e.clientX;
        dragScrollLeft = list.scrollLeft;
        list.classList.add('is-dragging');
      }

      function onDocumentMouseMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const dx = dragStartX - e.clientX;
        list.scrollLeft = dragScrollLeft + dx;
        dragStartX = e.clientX;
        dragScrollLeft = list.scrollLeft;
        hasDragged = true;
      }

      function onDocumentMouseUp() {
        if (!isDragging) return;
        isDragging = false;
        list.classList.remove('is-dragging');
        if (hasDragged) {
          list.dataset.justDragged = 'true';
          setTimeout(() => delete list.dataset.justDragged, 50);
        }
      }

      list.addEventListener('mousedown', onListMouseDown);
      document.addEventListener('mousemove', onDocumentMouseMove, { passive: false });
      document.addEventListener('mouseup', onDocumentMouseUp);
      list.addEventListener('mouseleave', onDocumentMouseUp);

    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCustomersAlsoBought(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (container && container.querySelector(SECTION_SELECTOR)) {
      initCustomersAlsoBought(container);
    }
  });
})();
